<template>
  <div>
    <div class="row">
      <div class="col">
        <h4>Bienvenido(a)
          <span v-if="user.current" class="name-text">
            {{ getFullName | capitalize }}
          </span>
          al portal de afiliación online.
        </h4>
      </div>
    </div>

    <el-row :gutter="40" justify="space-around" align="middle" class="panel-group mt-3" v-loading="loading">
      <el-col :xs="24" :sm="12" :lg="8" v-for="(item, index) in model.tipos" :key="index" class="card-panel-col">
        <el-card class="card-panel">
          <div class="d-flex align-items-center justify-content-between" @click="goTo(item.codigo)">
            <div>
              <span :class="getIcon(item.codigo)" class="box-icon"></span>
            </div>
            <div>
              <h5 class="mx-5">{{ item.glosa }}</h5>
            </div>
          </div>

        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {TipoSolicitud} from "@/enums/tipoSolicitud";
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import {Row, Col} from "element-ui";
import {mapState} from "vuex";

export default {
  name: "PanelBox",
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
  },
  mixins: [
    requestAfiliacionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    RouterMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    model: {
      seleccionado: '',
      tipos: [],
    },
  }),
  computed: {
    ...mapState({
      user: state => state.user,
      cognitoInfo: state => state.cognitoInfo,
    }),
    getFullName() {
      const name = JSON.parse(this.cognitoInfo.name)
      if (name !== null) {
        return `${name.nombres[0]} ${name.apellidos[0]} ${name.apellidos[1]}`
      }
      return this.user.current.firstLastName
    }
  },
  beforeMount() {
    this.getList()
  },
  methods: {
    getList() {
      this.getTiposSolicitud()
        .then(response => {
          this.$log.debug('getTiposSolicitud', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const datos = JSON.parse(response.data.datos)
            this.$log.debug(datos)

            this.model.tipos = datos
          } else {
            this.showError('Ocurrió un error inesperado al cargar los tipos de Solicitud')
          }
        })
        .catch(err => {
          this.$log.fatal('getTiposSolicitud', err.response, err.request)
          this.showError('Ocurrió un error inesperado al cargar los tipos de Solicitud')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getIcon(code) {
      switch (code) {
        case TipoSolicitud.afiliacionpartido:
          return 'el-icon-connection'
        case TipoSolicitud.renunciapartido:
          return 'el-icon-scissors'
        case TipoSolicitud.certificadoafiliacion:
          return 'el-icon-document'
        case TipoSolicitud.certificadohistorico:
          return 'el-icon-tickets'
        case TipoSolicitud.reclamo:
          return 'el-icon-s-comment'
        default:
          return ''
      }
    },
    goTo(code) {
      this.$log.debug('goTo', code)
      switch (code) {
        case TipoSolicitud.afiliacionpartido:
          this.navigate({name: 'afiliacion-solicitud'})
          break
        case TipoSolicitud.renunciapartido:
          this.navigate({name: 'renuncia-partido-politico'})
          break
        case TipoSolicitud.certificadoafiliacion:
          this.navigate({name: 'GeneracionCertificado'})
          break
        case TipoSolicitud.certificadohistorico:
          this.navigate({name: 'solicitudes-historicas'})
          break
        case TipoSolicitud.reclamo:
          this.navigate({name: 'reclamo'})
          break
        default:
          this.showWarn('No se ha implementado la función')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;
  min-height: 350px;
  min-width: 140px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    cursor: pointer;
    height: 140px;
    width: 300px;

    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .el-icon-s-comment {
        color: #fff;
        background: #40c9c6;
      }

      .el-icon-connection {
        color: #fff;
        background: #36a3f7;
      }

      .el-icon-scissors {
        color: #fff;
        background: #f4516c;
      }

      .el-icon-document {
        color: #fff;
        background: #b6a2de;
      }

      .el-icon-tickets {
        color: #fff;
        background: #E6A23C;
      }

    }

    .el-icon-s-comment {
      color: #40c9c6;
    }

    .el-icon-connection {
      color: #36a3f7;
    }

    .el-icon-scissors {
      color: #f4516c;
    }

    .el-icon-document {
      color: #b6a2de;
    }

    .el-icon-tickets {
      color: #E6A23C;
    }

    .card-panel-icon-wrapper {
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
  }
}

.box-icon {
  font-size: 4em;
}

.name-text {
  font-weight: bold;
  font-size: 28px;
}

</style>
